import { attachments } from '../attachment'
import { describeTable } from './describeTable'

describeTable(attachments, {
  description: `A file in S3 (photo, PDF, scanned card…) linked to any entity through entity_type + entity_id. The link is polymorphic and not enforced by a foreign key, and the naming is inconsistent: rows written by the generic CRUD path use the table name ('visits', 'opportunities', 'properties', 'customers'), hand-written paths use singular or camelCase ('visit', 'opportunity', 'customer', 'property', 'employee', 'user', 'invoice', 'chat_message', 'employeeCertificate', 'absence', 'inboxItem'). Match both forms when counting files for an entity. entity_type='pending' is an upload not yet linked to anything.
The file itself is not in the database; only its storage key. storage_key is not unique because copying an attachment to another entity references the same object.`,
  columns: {
    entityType:
      "Owning entity, e.g. 'visit' or 'visits' (see table description).",
    entityId: 'Id in the owning table.',
    filename: 'Original file name as uploaded.',
    filesize:
      'Bytes, client-reported and untrusted; fine for display, not for storage accounting.',
    mimeType: "e.g. 'image/jpeg', 'application/pdf'.",
    storageKey:
      'Object key in S3; shared when the same file is linked to several entities.',
    bucket:
      'private = signed URLs only (default); public = served openly (newsletter images, avatars).',
    metadata: 'Free JSON specific to the use (type, order, duration…).',
    uploadedBy: 'users.id of the uploader.',
    description: 'Optional caption.',
  },
})
